import { Fields } from '@yes.technology/react-toolkit'
import { findSectionLayoutField } from 'shared/hooks/useFilterFields/utils/findSectionLayoutField'
import { FieldSettings } from 'shared/types'
import { FilterSectionLayout } from 'site/Renderer/components/FilterFields/types'

export function updateDisplayText(
  fields: Fields,
  fieldSettings: FieldSettings,
  sectionsLayout?: FilterSectionLayout[]
): Fields {
  if (!fieldSettings || !fields) {
    return fields
  }

  const updatedFields: Fields = { ...fields }

  Object.entries(fieldSettings).forEach(([columnName, configField]) => {
    const originalField = updatedFields[columnName]

    const sectionLayoutField = findSectionLayoutField(
      sectionsLayout,
      configField.uuid
    )

    if (originalField) {
      updatedFields[columnName] = {
        ...originalField,
        display_text: {
          ...(originalField?.display_text ?? {}),
          des:
            configField?.display_text?.des ||
            sectionLayoutField?.datafield?.label ||
            originalField?.display_text?.des ||
            ''
        }
      }
    }
  })

  return updatedFields
}
